import { useLang } from '@/i18n';
import EfLink from '@elem/ui/ef-link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import css from './index.module.scss';

const INIT_PROCESS = 100;
const FP: React.FC = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [enter, setEnter] = useState<boolean>(false);
    const [active, setActive] = useState<number>(0);
    const [process, setProcess] = useState<number>(INIT_PROCESS);
    const { locale } = useRouter();
    let items: string[] = ['#dpu-detail-B', '#shp2-detail-G', '#shp2-detail-K', '#dpu-detail-O'];
    if (locale === 'us') {
        items = ['#dpu-detail-B', '#EnergyBackup-detail', '#UltraSavings-detail', '#CutCosts', '#OEu-detail'];
    }
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneEnter = AniContainer.create({
                triggerElement: '.dpu-launch-detail #dpu-detail-B',
                triggerHook: 1,
                offset: 0,
                duration: locale === 'us' ? '6000%' : '50000%',
                onEnter: () => setEnter(true),
                onLeave: () => setEnter(false),
            });

            let rangeArr: string[] = ['range1', 'range2', 'range3', 'range4'];
            if (locale === 'us') {
                rangeArr = ['range1', 'range2', 'range3', 'range4', 'range5'];
            }
            rangeArr.forEach((range: string, k: number) => {
                const rangeDom: HTMLDivElement | null = document.querySelector(`.dpu-launch-detail .${range}`);
                if (rangeDom) {
                    const rangeH = Number(rangeDom.offsetHeight);
                    const sceneProcess = AniContainer.create({
                        triggerElement: rangeDom,
                        triggerHook: 1,
                        duration: rangeH,
                        offset: 0,
                        onEnter: () => setActive(k),
                        onProcess: (rate: number) => setProcess(100 * (1 - rate)),
                    });
                    return () => {
                        sceneProcess.destroy();
                    };
                }
            });

            return () => {
                sceneEnter.destroy();
            };
        }
    }, []);

    return (
        <ul className={`fix-process ${css.section} ${enter ? 'enter' : ''}`}>
            {items?.map((item: string, k: number) => (
                <li className="item" key={k}>
                    <EfLink className={`pro-item ${active === k ? 'active' : ''}`} href={item}>
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" preserveAspectRatio="none">
                            <circle
                                cx="18"
                                cy="18"
                                r="16"
                                fill="#444444"
                                stroke="#FFFFFF"
                                strokeWidth="4"
                                strokeDashoffset="100"
                                strokeLinecap="round"
                                strokeDasharray="100 100"
                                style={{ strokeDashoffset: `${active === k ? process : INIT_PROCESS}px` }}
                            ></circle>
                        </svg>
                        <span className="item-name">{t(`Fix_Process${k + 1}`)}</span>
                    </EfLink>
                </li>
            ))}
        </ul>
    );
};

export default FP;
